import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M11 12H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 6H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 18H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 9v6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 12h-6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ListPlus";
const ListPlus = memo(themed(Icon));
export {
  ListPlus
};
//# sourceMappingURL=list-plus.js.map
